import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular'
import { PrivacyPageRoutingModule } from './privacy-routing.module';
import { PrivacyPage } from './privacy.page';
import { NucamptopnavModule } from '../../components/nucamptopnav/nucamptopnav.module';

import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
    PrivacyPageRoutingModule,
    IonicModule,
    CommonModule,
    NucamptopnavModule,
    PrivacyPage,
],
})
export class PrivacyPageModule {}
